import { HTMLAttributes } from "react";
import Button from "@components/AccessibleComponents/Button";
import { HeaderCommonProps } from "@components/Header/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { PressEvent } from "@react-types/shared";
import { cn, mySPHOpenLogin } from "@util/helpers";

export type LoginTriggerProps = {
  onToggleLogin?: (e: PressEvent) => void;
} & Pick<HTMLAttributes<HTMLDivElement>, "className"> &
  Pick<HeaderCommonProps, "textClassName">;

export default function MyAccountLoginTrigger({
  onToggleLogin,
  className = "lg:p-3",
  textClassName,
}: LoginTriggerProps): React.ReactElement {
  return (
    <Button
      className={cn(
        "cursor-pointer font-poppins text-2xs font-semibold opacity-100",
        "flex items-center justify-center rounded-[25px] leading-none tracking-tightest focus-within:outline-0 focus:outline-0 lg:hover:bg-gray-175",
        className,
        textClassName
      )}
      onPress={(e) => {
        mySPHOpenLogin();

        onToggleLogin && onToggleLogin(e);
      }}
      data-testid="user-login-trigger"
      aria-label="login trigger"
    >
      <span className="hidden lg:block">Sign in / Sign up for free</span>

      <IconFactory type={IconTypeEnum.profile} className="lg:hidden" />
    </Button>
  );
}
